import { Cohort, CountryCode } from 'root-constants'

// US geo cohort replacements (base cohort -> _am variant), grouped by app
type TCohortRedirects = Partial<Record<string, Cohort>>

const AYAH_PATH_US_REDIRECTS: TCohortRedirects = {
  [Cohort.AP_PA_440]: Cohort.AP_PA_440_AM,
  [Cohort.AP_PA_440_C]: Cohort.AP_PA_440_C_AM,
  [Cohort.AP_FINANCE_313]: Cohort.AP_FINANCE_313_AM,
  [Cohort.AP_FINANCE_313_C]: Cohort.AP_FINANCE_313_C_AM,
  [Cohort.AP_QURAN_313_C]: Cohort.AP_QURAN_313_C_AM,
  [Cohort.AP_QURAN_313_CF]: Cohort.AP_QURAN_313_C_AM,
  [Cohort.FLOW_AYAH_313]: Cohort.FLOW_AYAH_313_AM,
  [Cohort.FINAL_MONTHLY_AYAH]: Cohort.FINAL_MONTHLY_AYAH_AM,
}

const KARMA_PATH_US_REDIRECTS: TCohortRedirects = {
  [Cohort.FINAL_MONTHLY_KARMA]: Cohort.FINAL_MONTHLY_KARMA_AM,
  [Cohort.KP_BS_13]: Cohort.KP_BS_13_AM,
}

const BLESSED_PATH_US_REDIRECTS: TCohortRedirects = {
  [Cohort.FLOW_1_INTRO_LONG_2271]: Cohort.FLOW_1_INTRO_LONG_2271_AM,
  [Cohort.FINAL_MONTHLY]: Cohort.FINAL_MONTHLY_AM,
}

// Country-specific cohort replacements for target cohorts
export const COHORT_REDIRECTS_BY_COUNTRY_CODE: Partial<
  Record<string, TCohortRedirects>
> = {
  [CountryCode.UNITED_STATES]: {
    ...AYAH_PATH_US_REDIRECTS,
    ...KARMA_PATH_US_REDIRECTS,
    ...BLESSED_PATH_US_REDIRECTS,
  },
}

export const getCohortByCountryCode = ({
  cohort,
  countryCode,
}: {
  cohort: string
  countryCode: string
}): string => {
  const normalizedCountryCode = countryCode.trim().toLowerCase()

  return (
    COHORT_REDIRECTS_BY_COUNTRY_CODE[normalizedCountryCode]?.[cohort] ?? cohort
  )
}
